import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AdminProvider } from './context/AdminContext';
import { Toaster } from './components/ui/toaster';

import Header from './components/Header';
import Footer from './components/Footer';
import PotraitChocolateLanding from './pages/PotraitChocolateLanding';
import Home from './pages/HomeImproved';
import Catalog from './pages/Catalog';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Contact from './pages/Contact';
import Account from './pages/Account';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminCollections from './pages/admin/AdminCollections';
import AdminOrders from './pages/admin/AdminOrders';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminSettings from './pages/admin/AdminSettings';
import AdminAffiliates from './pages/admin/AdminAffiliates';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import AdminMessages from './pages/admin/AdminMessages';
import PageEditor from './pages/admin/PageEditor';
import QRTemplates from './pages/admin/QRTemplates';
import TestingDashboard from './pages/admin/TestingDashboard';
import PhotoBoothDashboard from './pages/admin/PhotoBoothDashboard';
import PhotoBoothEditor from './pages/admin/PhotoBoothEditor';
import PhotoBoothUpload from './pages/admin/PhotoBoothUpload';
import PrintMonitor from './pages/admin/PrintMonitor';
import ClientSubmissions from './pages/admin/ClientSubmissions';
import AdminPhotoBoothPage from './pages/admin/AdminPhotoBoothPage';
import AdminShippingSettings from './pages/admin/AdminShippingSettings';
import AdminSeedProducts from './pages/admin/AdminSeedProducts';
import AffiliateRegister from './pages/AffiliateRegister';
import AffiliateDashboard from './pages/AffiliateDashboard';
import AffiliateLogin from './pages/AffiliateLogin';
import UserRegister from './pages/UserRegister';
import UserLogin from './pages/UserLogin';
import UserPortal from './pages/UserPortal';
import SharedTemplate from './pages/SharedTemplate';
import SharedEditor from './pages/SharedEditor';
import ErrorBoundary from './components/ErrorBoundary';
import CheckoutSuccess from './pages/CheckoutSuccess';
import ARViewer from './pages/ARViewer';
import OreoCookieProduct from './pages/OreoCookieProduct';
import LivePhotoBooth from './pages/LivePhotoBooth';

function App() {
  return (
    <AdminProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="App flex flex-col min-h-screen">
            <Routes>
              {/* Admin Routes (no header/footer) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/products" element={<AdminProducts />} />
              <Route path="/admin/collections" element={<AdminCollections />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/newsletter" element={<AdminNewsletter />} />
              <Route path="/admin/messages" element={<AdminMessages />} />
              <Route path="/admin/coupons" element={<AdminCoupons />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/affiliates" element={<AdminAffiliates />} />
              <Route path="/admin/page-editor" element={<PageEditor />} />
              <Route path="/admin/qr-templates" element={<QRTemplates />} />
              <Route path="/admin/testing" element={<TestingDashboard />} />
              <Route path="/admin/photo-booth" element={<PhotoBoothDashboard />} />
              <Route path="/admin/photo-booth/:templateId" element={<PhotoBoothEditor />} />
              <Route path="/admin/photo-booth/:templateId/editor" element={<PhotoBoothEditor />} />
              <Route path="/admin/clients" element={<ClientSubmissions />} />
              <Route path="/admin/photobooth-page" element={<AdminPhotoBoothPage />} />
              <Route path="/admin/shipping" element={<AdminShippingSettings />} />
              <Route path="/admin/seed-products" element={<AdminSeedProducts />} />
              <Route path="/print-monitor/:templateId" element={<PrintMonitor />} />
              <Route path="/upload/:templateId" element={<PhotoBoothUpload />} />
              
              {/* User Portal - for users with shared template access */}
              <Route path="/portal" element={<UserPortal />} />
              
              {/* Direct share link - anyone with the link can access */}
              <Route path="/shared/:templateId" element={<SharedTemplate />} />
              <Route path="/shared/:templateId/editor" element={<SharedEditor />} />

              {/* Main Landing Page (no header/footer) */}
              <Route path="/" element={<PotraitChocolateLanding />} />

              {/* Edible Greetings Store Routes (with header/footer) */}
              <Route path="/edible-greetings/*" element={
                <>
                  <Header />
                  <main className="flex-1">
                    <ErrorBoundary>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/catalog" element={<Catalog />} />
                        <Route path="/product/oreo-cookies" element={<OreoCookieProduct />} />
                        <Route path="/product/:id" element={<ProductDetail />} />
                        <Route path="/cart" element={<Cart />} />
                        <Route path="/checkout" element={<Checkout />} />
                        <Route path="/checkout/success" element={<CheckoutSuccess />} />
                      </Routes>
                    </ErrorBoundary>
                  </main>
                  <Footer />
                </>
              } />

              {/* AR Viewer (fullscreen, no header/footer) */}
              <Route path="/ar/:cardId" element={<ARViewer />} />

              {/* Live Photo Booth (fullscreen, no header/footer) */}
              <Route path="/live-photobooth" element={<LivePhotoBooth />} />

              {/* Other Public Routes (with header/footer) */}
              <Route path="/*" element={
                <>
                  <Header />
                  <main className="flex-1">
                    <Routes>
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/account" element={<Account />} />
                      <Route path="/register" element={<UserRegister />} />
                      <Route path="/login" element={<UserLogin />} />
                      <Route path="/affiliate/register" element={<AffiliateRegister />} />
                      <Route path="/affiliate/login" element={<AffiliateLogin />} />
                      <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
                      <Route path="/product/oreo-cookies" element={<OreoCookieProduct />} />
                      <Route path="/cart" element={<Cart />} />
                      <Route path="/checkout" element={<Checkout />} />
                      <Route path="/checkout/success" element={<CheckoutSuccess />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
            <Toaster />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AdminProvider>
  );
}

export default App;
